<template>
  <ion-toolbar>
    <ion-buttons slot="start" v-if="
        $store.state.pages.auth.back.length || routeName == 'profile_gallery'
      ">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end" v-if="routeName != 'profile_gallery'">
      <ion-button @click="skip" class="pill next-pill-button">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <!-- <div class="page_title">Pharmacy Photo & Video</div> -->
    <div class="container onboarding">
      <page-title :title="`${messages.employer} Photo & Video`" :subtitle="'Adding '+pageTitleName+' photos and videos will increase your chances of finding a ' + $filters.systemLocumName(false, false)" showIcon />
      <el-form :model="formsData.galleryForm" :rules="formsData.galleryForm.rules"
        :ref="(el) => (formsData.galleryForm.ref = el)" :label-position="'top'" @submit.prevent="submit('galleryForm')">
        <!-- <div class="form_text">
          <div class="text">
            Adding pharmacy photos and videos will increase your chances of
            finding a locum.
          </div>
        </div> -->
        <!-- <div>
          <div class="text">Upload new Photo or Video</div>
        </div> -->
        <el-form-item class="mb0" prop="files">
          <el-upload class="preview_square-block" :ref="(el) => (formsData.galleryForm.files.ref = el)"
            :action="BASE_URL + '/feedback'" name="files"
            accept="video/mp4,video/avi,video/mpeg,video/quicktime,image/png,image/jpg,image/jpeg" list-type="picture"
            :thumbnail-mode="true" :auto-upload="false" :multiple="true" :limit="formsData.galleryForm.files.limit"
            @remove="imageRemove" @change="imageChange" :before-upload="beforeUpload"
            :disabled="formsData.galleryForm.files.disabled" @exceed="imageLimit" :drag="true">
            <template #file="{ file }">
              <div @click="imagePreviewModalOpen(file)" class="thumbnail_img"
                v-if="$filters.getFileType(file.raw) == 'image'">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              </div>
              <div class="thumbnail_img" v-if="$filters.getFileType(file.raw) == 'video'">
                <img class="el-upload-list__item-thumbnail" :src="
                    formsData.galleryForm.files.posters[
                      formsData.galleryForm.files.value.indexOf(file)
                    ]
                  " alt="" />
                <span class="el-upload-list__item-video-play" @click="videoPreviewModalOpen(file.url, file.raw.type)">
                  <span class="locumate_icons locumate_icon-video_play"></span>
                </span>
              </div>
              <div class="upload-file-details">
                <div class="el-upload-list__item-name">{{ file.name }}</div>
                <div class="el-upload-list__item-info"></div>
              </div>
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-delete" @click="imageRemove(file, fileList)">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21.0702 5.23C19.4602 5.07 17.8502 4.95 16.2302 4.86V4.85L16.0102 3.55C15.8602 2.63 15.6402 1.25 13.3002 1.25H10.6802C8.35016 1.25 8.13016 2.57 7.97016 3.54L7.76016 4.82C6.83016 4.88 5.90016 4.94 4.97016 5.03L2.93016 5.23C2.51016 5.27 2.21016 5.64 2.25016 6.05C2.29016 6.46 2.65016 6.76 3.07016 6.72L5.11016 6.52C10.3502 6 15.6302 6.2 20.9302 6.73C20.9602 6.73 20.9802 6.73 21.0102 6.73C21.3902 6.73 21.7202 6.44 21.7602 6.05C21.7902 5.64 21.4902 5.27 21.0702 5.23Z"
                      fill="rgb(var(--locumate-clr-danger))" />
                    <path
                      d="M19.2302 8.14C18.9902 7.89 18.6602 7.75 18.3202 7.75H5.68024C5.34024 7.75 5.00024 7.89 4.77024 8.14C4.54024 8.39 4.41024 8.73 4.43024 9.08L5.05024 19.34C5.16024 20.86 5.30024 22.76 8.79024 22.76H15.2102C18.7002 22.76 18.8402 20.87 18.9502 19.34L19.5702 9.09C19.5902 8.73 19.4602 8.39 19.2302 8.14ZM13.6602 17.75H10.3302C9.92024 17.75 9.58024 17.41 9.58024 17C9.58024 16.59 9.92024 16.25 10.3302 16.25H13.6602C14.0702 16.25 14.4102 16.59 14.4102 17C14.4102 17.41 14.0702 17.75 13.6602 17.75ZM14.5002 13.75H9.50024C9.09024 13.75 8.75024 13.41 8.75024 13C8.75024 12.59 9.09024 12.25 9.50024 12.25H14.5002C14.9102 12.25 15.2502 12.59 15.2502 13C15.2502 13.41 14.9102 13.75 14.5002 13.75Z"
                      fill="rgb(var(--locumate-clr-danger))" />
                  </svg>

                </span>
              </span>
            </template>
            <el-button class="image_upload" type="transparent" v-if="!formsData.galleryForm.files.disabled">
              <span class="image">
                <!-- <span class="locumate_icons locumate_icon-picture"></span> -->
                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M27 4.5V18L31.5 13.5" stroke="black" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M27 18L22.5 13.5" stroke="black" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M15.75 27C6.75 27 6.75 31.0275 6.75 36V38.25C6.75 44.46 6.75 49.5 18 49.5H36C45 49.5 47.25 44.46 47.25 38.25V36C47.25 31.0275 47.25 27 38.25 27C36 27 35.37 27.4725 34.2 28.35L31.905 30.78C29.25 33.615 24.75 33.615 22.0725 30.78L19.8 28.35C18.63 27.4725 18 27 15.75 27Z"
                    stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.25 26.9998V17.9998C11.25 13.4773 11.25 9.74234 18 9.08984" stroke="black"
                    stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M42.75 26.9998V17.9998C42.75 13.4773 42.75 9.74234 36 9.08984" stroke="black"
                    stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span class="upload-title" style="margin-bottom:0px">Select image/video</span>
              <span>
                <div class="upload-info" style="margin-bottom: 0px; font-size: 0.6rem;">Please upload only MP4, JPEG or PNG.</div>
              </span>
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button v-if="!formsData.galleryForm.disabled" class="submit_page w-full mt-4" type="blue"
            @click="submit('galleryForm')" :disabled="formsData.galleryForm.disabled">
            Upload
          </el-button>
        </el-form-item>
        <template v-if="files.length">
          <div class="form_text">
            <div class="text">Gallery</div>
          </div>
          <div class="preview_square preview_square-block">
            <div class="el-upload-list">
              <div class="el-upload-list__item" v-for="(file, i) in files" :key="file.url">
                <div class="thumbnail_img" @click="imagePreviewModalOpen(file)"
                  v-if="$filters.getFileType(file) == 'image'">
                  <img class="el-upload-list__item-thumbnail locumate_icons locumate_icon-picture" :src="file.url"
                    alt="" />
                </div>
                <div class="thumbnail_img" v-if="$filters.getFileType(file) == 'video'">
                  <video class="el-upload-list__item-thumbnail">
                    <source :src="file.url + '#t=0.001'" :type="'video/' + $filters.getFileExt(file.url)" />
                  </video>
                  <span class="el-upload-list__item-video-play" @click="
                      videoPreviewModalOpen(
                        file.url,
                        'video/' + $filters.getFileExt(file.url)
                      )
                    ">
                    <span class="locumate_icons locumate_icon-video_play"></span>
                  </span>
                </div>
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete" @click="fileDelete(i, file)">
                    <span class="locumate_icons locumate_icon-close"></span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </template>
        <el-form-item class="button_submit mb0" v-if="routeName == 'auth_gallery'">
          <el-button class="submit" type="blue" @click="goNext" :disabled="files.length == 0">
            Continue
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <modal-video-preview :modalName="'videoPreviewModal'" :options="videoPreviewModal" />

  <preview-modal :modalName="'previewModal'" :options="previewModal" />
</template>

<script>
import { ref, onMounted, inject, nextTick, computed } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import videoCreatePoster from "@/helpers/video/createPoster";
import FileHelpers from "@/helpers/file/file";

import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";

import { VideoPreviewModal, PreviewModal } from "@/modals/modals";

import { ElLoading } from "element-plus";
// import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
import PageTitle from "@/components/PageTitle/PageTitle.vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    // SvgIcon,
    "modal-video-preview": VideoPreviewModal,
    "preview-modal": PreviewModal,
    "page-title": PageTitle
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    // const loading = ref(false);

    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const $modals = inject("$modals");
    const messages = inject('messages');

    const fileHelpers = new FileHelpers();

    const routeName = $route.name;
    const reportUserData = $store.getters.getReportData.userData;
    const shift = $store.getters.getReportData.shiftData;

    const BASE_URL = process.env.VUE_APP_BASEURL;

    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;

    const files = ref($route.params.files);
    console.log(files.value);
    const reloadPage = () => {
      ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      $router.go(0);
    };
    const formsDataArray = {
      galleryForm: {
        files: {
          ref: null,
          disabled: false,
          value: [],
          posters: [],
          limit: 10,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "gallery",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
      },
    };

    const checkFilesLimit = (length, limit) => {
      if (length >= limit) {
        return true;
      } else return false;
    };

    const imageRemove = (file) => {
      const imageId = formsData.galleryForm.files.value.indexOf(file);
      formsData.galleryForm.files.value.splice(imageId, 1);
      formsData.galleryForm.files.posters.splice(imageId, 1);
      formsData.galleryForm.files.disabled = checkFilesLimit(
        formsData.galleryForm.files.value.length,
        formsData.galleryForm.files.limit
      );
      checkFormValidation("galleryForm", true, "files");
    };

    const imageChange = (file, fileList) => {
      console.log("befor insert", formsData.galleryForm.files.value);
      console.log("image change", file.raw.type);
      if (
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/png" ||
        file.raw.type === "video/mp4"
      ) {
        const setPoster = (posterUrl) => {
          formsData.galleryForm.files.posters.push(posterUrl);
          console.log(posterUrl);
        };

        console.log(fileHelpers.getFileType(file));

        if (fileHelpers.getFileType(file) == "video") {
          console.log(fileHelpers.getFileType(file));
          (async () => {
            try {
              await videoCreatePoster(file.url, 0.01, setPoster);
              console.log(formsData.galleryForm.files.posters);
            } catch (error) {
              console.log(error);
            }
          })();
        } else {
          formsData.galleryForm.files.posters.push(null);
        }

        checkFormValidation("galleryForm", true, "files");
        formsData.galleryForm.files.value = fileList;
        formsData.galleryForm.files.disabled = checkFilesLimit(
          formsData.galleryForm.files.value.length,
          formsData.galleryForm.files.limit
        );
      } else {
        fileList.pop();
        ElMessage({
          type: "error",
          message: "File must be a type of mp4,png,jpg,jpeg",
        });
      }
    };

    const imageLimit = (files, fileList) => {
      let errors = `The limit is ${
        formsData.galleryForm.files.limit
      }, you selected ${files.length} files this time, add up to ${
        files.length + fileList.length
      } totally`;
      setFieldError("galleryForm", "files", errors);
      checkFormValidation("galleryForm", true, "files");
      nextTick(() => {
        setFormValidation("galleryForm", "files", true);
      });
    };

    const beforeUpload = (rawFile) => {
      console.log(rawFile);
    };

    const videoPreviewModal = ref({
      name: "videoPreview",
    });

    const videoPreviewModalOpen = (videoUrl, videoType) => {
      console.log(videoType);
      $modals.open("videoPreviewModal", {
        videoUrl: videoUrl,
        videoType: videoType,
      });
    };
    const previewModal = ref({
      name: "imagePreview",
      file: [],
    });
    const imagePreviewModalOpen = (file) => {
      previewModal.value.file = file;
      $modals.open("previewModal", {
        file: file,
      });
    };

    const goBack = async() => {
      if (routeName == "profile_gallery") {
        $router.push({
          name: "profile_edit",
        });
      } else {
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
            name: back,
        });  
      }
    };

    const goNext = () => {
      $router.push({
        name: "auth_workEnvironment",
      });
    };

    const skip = () => {
      $store.dispatch("addAuthPageBack", $route.name);
      goNext();
    };

    onMounted(() => {
      setPageClassGlobal("global_auth_page");
      checkFormValidation("galleryForm", false);
      setFormRefs();
    });

    // Listen for the router's "afterEach" event to update the loading state
    $router.afterEach(() => {
      ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      }).close();
    });

    const fileDelete = async (id) => {
      try {
        await ElMessageBox.confirm(
          `Are you sure you’d like to remove file from gallery?`,
          "Remove file",
          {
            confirmButtonText: "Remove",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--red",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );
        await $store.dispatch("DELETE_USER_GALLERY_FILE", files.value[id].id);
        files.value.splice(id, 1);
      } catch (error) {
        console.log(error);
      }
    };

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              let formValues = getFormValues(formName);
              console.log("all files befor", formValues);
              const form = new FormData();
              const filesLength = formValues.files.length;

              for (let i = 0; i < filesLength; i++) {
                const file = formValues.files[i];
                console.log(file);
                form.append("file", file);
                const resp = await $store.dispatch(
                  "UPLOAD_USER_GALLERY_FILE",
                  form
                );

                let message = "File has been uploaded";

                ElMessage({
                  type: "success",
                  message: message,
                });
                files.value.push(resp);
                formsData.galleryForm.files.value.splice(0, 1);
                formsData.galleryForm.files.posters.splice(0, 1);
                if (routeName == "profile_gallery") {
                  const respGal = await $store.dispatch("GET_USER_GALLERY");
                  console.log("🚀 ~ respGal:", respGal)
                  files.value = respGal.data;  
                  console.log("🚀 ~ files:", files)
             
                } else {
                  $router.push({
                    name: "auth_workEnvironment",
                  });
                }
              }
              checkFormValidation("galleryForm", false, "files");
            } catch (error) {
              console.log(error);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const pageTitleName = computed(() => {
      const employer = messages.employer;
      return `${employer.charAt(0).toLowerCase()}${employer.slice(1)}`;
    });

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFieldError,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      routeName,
      reportUserData,
      formsData,
      userRole,
      goBack,
      goNext,
      skip,
      submit,
      imageRemove,
      imageChange,
      beforeUpload,
      imageLimit,
      BASE_URL,
      shift,
      videoPreviewModalOpen,
      videoPreviewModal,
      fileDelete,
      files,
      reloadPage,
      imagePreviewModalOpen,
      previewModal,
      messages,
      pageTitleName
    };
  },
};
</script>
